let LayoutFactor={
    "PriceChart":63,
    "Insider":7,
    "Volume":15,
    "TechnicalIndicator":15
}
export default LayoutFactor;